<app-base-analytics-page
  [reportTitle]="'ES Analytics'"
  (onPdfExport)="onParentPdfExport($event)"
>
  <kendo-pdf-export
    #pdf
    paperSize="A4"
    [landscape]="true"
    margin="1cm"
    [scale]="0.6"
    forcePageBreak=".page-break"
    [imageResolution]="300"
  >
    <!-- Protection Coverage Status -->
    <div class="row g-3 mb-3">
      <div class="col-lg col-md-6 col-sm-12">
        <app-es-events-pending-review-card
          [eventsPendingReview]="eventsPendingReviewResponse()"
        ></app-es-events-pending-review-card>
      </div>
      <!-- MF - Data for this card is not yet available in the checkpoint API -->
      <!-- <div class="col-lg col-md-6 col-sm-12">
        <app-es-config-status-card
          [configStatus]="configStatusResponse()"
          [organizationId]="organizationId()"
          (configChanged)="onConfigStatusChanged()"
        ></app-es-config-status-card>
      </div> -->
    </div>

    <!-- Current Threat Campaign Analysis -->
    <div class="row mb-3">
      <div class="col-12">
        <app-es-threat-campaign-chart
          [threatCampaignResponse]="threatCampaignResponse()"
        ></app-es-threat-campaign-chart>
      </div>
    </div>

    <!-- filter row -->
    <div class="row mb-3">
      <app-analytics-filter
        [timeRanges]="timeRanges"
        [filterConfig]="filterConfig"
        [selectedTimeRange]="selectedTimeRange"
        [startDate]="startDate || null"
        [endDate]="endDate || null"
        (onTimeRangeChange)="onTimeRangeChange($event)"
        (onStartDateChange)="onStartDateChange($event)"
        (onEndDateChange)="onEndDateChange($event)"
        (onApplyFilters)="applyFilters()"
      ></app-analytics-filter>
    </div>

    <!-- Email Security Distillation Pipeline -->
    <div class="row mb-3">
      <div class="col-12">
        <app-es-distillation-funnel
          [emailFunnel]="emailFunnelResponse()"
          [organizationId]="organizationId()"
        ></app-es-distillation-funnel>
      </div>
    </div>

    <!-- Threats by Type and Layered Protection Charts-->
    <div class="row g-3 mb-3">
      <div class="col-xl col-12">
        <app-es-sec-events-breakdown [emailThreatsByType]="emailThreatsByTypeResponse()"></app-es-sec-events-breakdown>
      </div>
      <div class="col-xl col-12">
        <app-es-cp-protection [checkpointProtectionData]="checkpointProtectionResponse()"></app-es-cp-protection>
      </div>
    </div>

    <!-- Top Attacked Users -->
    <div class="row mb-3">
      <div class="col-12">
        <app-es-top-attacked-users
          [topAttackedUsers]="topAttackedUsersResponse()"
        ></app-es-top-attacked-users>
      </div>
    </div>

    <!-- Geographic Threats -->
    <div class="row g-3 mb-3">
      <div class="col-xl-3 col-12">
        <app-es-geographic-threats [geographicThreats]="geographicThreatsResponse()"></app-es-geographic-threats>
      </div>
      <div class="col-xl-9 col-12">
        <app-es-shadow-it-trend [shadowItTrendsData]="shadowItTrendsResponse()"></app-es-shadow-it-trend>
      </div>
    </div>
  </kendo-pdf-export>
</app-base-analytics-page>
